<!-- Page header-->
<app-public-header></app-public-header>
<!-- Page content-->
<router-outlet></router-outlet>